import React, { useState } from 'react';
import {
    Button,
    SaveButton,
    useCreate,
    useNotify,
    useRefresh,
    FormWithRedirect,
} from 'react-admin';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import IconCancel from '@material-ui/icons/Cancel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

function PayCourseBtn({ onChange, courseId }) {
    const [showDialog, setShowDialog] = useState(false);
    const [create, { loading }] = useCreate(`courses/${courseId}/pay`);
    const refresh = useRefresh();
    const notify = useNotify();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSubmit = async values => {
        create(
            { payload: { data: {} } },
            {
                onSuccess: ({ data }) => {
                    setShowDialog(false);
                    refresh();

                    onChange();
                },
                onFailure: ({ error }) => {
                    notify(error.message, 'error');
                },
            }
        );
    };
    return (
        <>
            <Button onClick={handleClick} label="resources.courses.actions.pay">
                <RemoveCircleIcon />
            </Button>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Pay Course"
            >
                <DialogTitle>Payer la course</DialogTitle>

                <FormWithRedirect
                    resource="courses"
                    save={handleSubmit}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving,
                    }) => (
                        <>
                            <DialogContent>
                                <p>
                                    Êtes-vous sûr bien vouloir rendre cette
                                    course payée
                                </p>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    label="ra.action.cancel"
                                    onClick={handleCloseClick}
                                    disabled={loading}
                                >
                                    <IconCancel />
                                </Button>
                                <SaveButton
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    label="resources.courses.actions.pay"
                                    pristine={pristine}
                                    saving={saving}
                                    disabled={loading}
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
}

export default PayCourseBtn;
